import { motion } from "framer-motion";
import AnimatedCounter from "@/components/AnimatedCounter";

const STATS = [
  {
    label: "Refunds at Stake",
    prefix: "$",
    target: 166,
    suffix: "B+",
    testId: "stat-refunds",
  },
  {
    label: "Affected Importers",
    prefix: "",
    target: 301000,
    suffix: "+",
    testId: "stat-importers",
  },
  {
    label: "Typical Recovery",
    prefix: "$",
    target: "50K–3M+",
    suffix: "",
    testId: "stat-recovery",
  },
  {
    label: "Contingency Fee",
    prefix: "",
    target: 20,
    suffix: "%",
    testId: "stat-fee",
  },
];

export default function StatsStrip() {
  return (
    <section
      data-testid="stats-section"
      className="section-dark relative overflow-hidden border-y border-white/10"
    >
      <div className="absolute inset-0 grid-lines opacity-30" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-24">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="flex items-center gap-3 mb-12"
        >
          <span className="h-px w-10 bg-[#F5B800]" />
          <span className="font-mono uppercase tracking-[0.24em] text-[11px] text-[#F5B800]">
            The Scale of Recovery
          </span>
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-14 gap-x-8">
          {STATS.map((s, idx) => (
            <motion.div
              key={s.label}
              data-testid={s.testId}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: idx * 0.1 }}
              className="relative"
            >
              <div className="font-serif text-white text-4xl sm:text-5xl lg:text-6xl leading-none tracking-tight">
                <AnimatedCounter
                  target={s.target}
                  prefix={s.prefix}
                  suffix={s.suffix}
                />
              </div>
              <div className="mt-4 h-px w-10 bg-[#F5B800]" />
              <div className="mt-4 font-mono uppercase tracking-[0.18em] text-[11px] text-white/60">
                {s.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
